"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeprecatedSelect = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var react_select_1 = tslib_1.__importDefault(require("react-select"));

var creatable_1 = tslib_1.__importDefault(require("react-select/creatable"));

var clear_indicator_1 = require("./partials/deprecated/clear-indicator");

var control_1 = require("./partials/deprecated/control");

var dropdown_indicator_1 = require("./partials/deprecated/dropdown-indicator");

var multi_value_1 = require("./partials/deprecated/multi-value");

var multi_value_remove_1 = require("./partials/deprecated/multi-value-remove");

var option_1 = require("./partials/deprecated/option");

var placeholder_1 = require("./partials/deprecated/placeholder");

var single_value_1 = require("./partials/deprecated/single-value");

var select_styles_1 = require("./styled/deprecated/select-styles");

var createCustomComponents = function createCustomComponents(opts) {
  return {
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    },
    ClearIndicator: (0, clear_indicator_1.createClearIndicator)(opts.clear),
    DropdownIndicator: (0, dropdown_indicator_1.createDropdownIndicator)(opts.dropdown),
    MultiValueRemove: (0, multi_value_remove_1.createMultiValueRemove)(opts.multiValueRemove),
    Option: option_1.Option,
    Control: control_1.Control,
    Placeholder: placeholder_1.Placeholder,
    SingleValue: single_value_1.SingleValue,
    MultiValue: multi_value_1.MultiValue
  };
};

function DeprecatedSelect(_a) {
  var iconAccessibilityProps = _a.iconAccessibilityProps,
      isCreatable = _a.isCreatable,
      propStyles = _a.styles,
      components = _a.components,
      _b = _a.size,
      size = _b === void 0 ? 'medium' : _b,
      props = tslib_1.__rest(_a, ["iconAccessibilityProps", "isCreatable", "styles", "components", "size"]);

  return isCreatable ? react_1.default.createElement(creatable_1.default, tslib_1.__assign({}, props, {
    components: tslib_1.__assign(tslib_1.__assign({}, createCustomComponents(iconAccessibilityProps)), components),
    styles: (0, select_styles_1.getStyles)(size, propStyles)
  })) : react_1.default.createElement(react_select_1.default, tslib_1.__assign({}, props, {
    components: tslib_1.__assign(tslib_1.__assign({}, createCustomComponents(iconAccessibilityProps)), components),
    styles: (0, select_styles_1.getStyles)(size, propStyles)
  }));
}

exports.DeprecatedSelect = DeprecatedSelect;